import React from 'react';
import {Table} from 'semantic-ui-react';

const WIDTH_COL = '8';

const ItemRow = ({row, columns, leftSide, widthColumn}) => {
  return (
    <Table.Row>
      { columns.map((pk, idx) =>
        <Table.Cell
          key={idx}
          width={widthColumn.includes(idx) ? WIDTH_COL : null}
          textAlign={leftSide.includes(idx) ? 'right' : 'left'} >
          { row[pk]}
        </Table.Cell>
      )}
    </Table.Row>
  );
};


const TableKanban = ({title, header, columns, data = [], totals = [], leftSide = [], widthColumn = []}) => {
  if (data.length === 0) {
    return null;
  }
  return (
    <div className="table-kanban-logistic">
      <h3>{title}</h3>
      <Table celled >
        <Table.Header>
          <Table.Row>
            {header.map((item, idx) => <Table.HeaderCell
              width={widthColumn.includes(idx) ? WIDTH_COL : null}
              key={item} >{item}</Table.HeaderCell>)}
          </Table.Row>
        </Table.Header>
  
        <Table.Body>
          {data.map((row, idx) => (
            <ItemRow
              row={row}
              columns={columns}
              key={idx}
              leftSide={leftSide}
              widthColumn={widthColumn} />)
          )}
          {totals.length > 0 &&
            <Table.Row>
              {totals.map((item, idx) =>
                <Table.Cell
                  key={idx}
                  width={widthColumn.includes(idx) ? WIDTH_COL : null}
                  textAlign={leftSide.includes(idx) ? 'right' : 'left'} >{item}</Table.Cell>)}
            </Table.Row>
          }
        </Table.Body>
      </Table>
    </div>
  );
};

export default TableKanban;
